module.exports = __webpack_public_path__ + "media/images/play_store-b424ae9d41f172957b576a252568ce9f.png";